import { isBootstrapAllowed, renderStaticPageNotFound } from './access-gate';
import { clearBrowserCacheIfDeployed } from './app/services/cache-buster';

if (!isBootstrapAllowed()) {
  renderStaticPageNotFound();
} else {
  clearBrowserCacheIfDeployed().finally(() => {
    import('./bootstrap-app')
      .then((m) => m.bootstrapUr3plsApp())
      .catch((err) => console.error(err));
  });
}
